import React from 'react';
import { Icon } from './Icon.js';
export const IconHouseBolt = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 21V8.75L12 2L3 8.75V21H21Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M11.2363 12H16.2363L13.2363 18H11L13 14H8L11 8H13.2363L11.2363 12Z", fill: "currentColor", "data-stroke": "none" })));
};
//# sourceMappingURL=IconHouseBolt.js.map